module.exports = [
  require('./jims_glowing_coin'),
  require('./jims_magic_missile'),
]
